import Link from 'next/link';

import { Template } from '@repo/editor/src/types';

import { Remix } from './style';

export const DesignPostRemix = ({
  remixOfTemplate,
}: {
  remixOfTemplate: Template | undefined;
}) => {
  if (
    remixOfTemplate?.createdBy?.slug &&
    (remixOfTemplate?.id || remixOfTemplate.postId)
  ) {
    return (
      <Remix>
        Remix of{' '}
        <Link
          href={`/${remixOfTemplate.createdBy.slug}/${remixOfTemplate.postId ?? remixOfTemplate.id}`}
        >
          <b>
            {remixOfTemplate.createdBy.name} - {remixOfTemplate.name}
          </b>
        </Link>
      </Remix>
    );
  }
  return null;
};
